// Module
var code = `<app-select-guest-amenities *ngIf="propertyValidated && cartItemsValidated"
                            [isGuest] = true
                            [property] = "property"
                            [cartItems] = "cartItems"
                            [itemsTotal] = "itemsTotal"
                            [allowPayByCheck] = "allowPayByCheck"
                            [allowPayByCard] = "allowPayByCheck"
                            [availableAmenities] = "availableAmenities"
                            [availableCategories] = "availableCategories"
                            [filteredAmenities] = "availableAmenities"
                            [selectedCategory] = "availableCategories[0]">
</app-select-guest-amenities>`;
// Exports
module.exports = code;